import React, { Component } from "react";

import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  Table
} from "react-bootstrap";

import { Navbar } from "react-bootstrap";

import HeaderLinks from "../../components/Header/HeaderLinks.jsx";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import InputMask from 'react-input-mask';

import { ProductCard } from "../../components/ProductCard/ProductCard.jsx";

import logo from "../../assets/img/logo-white.png";

import logo_thumb from "../../assets/img/logo-thumb.png";
import background1 from "../../assets/img/background1.png";

const restLink_account = new HttpLink({ credentials: 'include', uri: "/api/v1/account/" });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

const REGISTER = gql`
mutation createAccountByUser($name: String!, $cpf: String!, $mail: String!, $cellphone: String!, $title: String!, $company: String!, $cnpj: String!, $phone: String!, $pass: String!, $repass: String!){
    createAccountByUser( name:$name, cpf:$cpf, mail:$mail, cellphone:$cellphone, title:$title, company:$company, cnpj:$cnpj, phone:$phone, pass:$pass, repass:$repass){
      id
      token
      msg_error
    }
  }
`;



class Register extends Component {
  
  state = {
    accepted_terms: false,
    name: "",
    cpf: "",
    mail: "",
    cellphone: "",
    phone: "",
    title: "",
    company: "",
    cnpj: "",
    pass: "",
    repass: "",
    msg: "",
    msg_type: "info"
  }


  login = async () => {
    
      const mutationReturn = (await account_client.mutate({
        variables: {
          name:this.state.name, 
          mail: this.state.mail, 
          cpf: this.state.cpf, 
          cellphone:this.state.cellphone, 
          company:this.state.company,
          cnpj:this.state.cnpj,
          title:this.state.title, 
          phone:this.state.phone, 
          pass:this.state.pass, 
          repass:this.state.repass
        },
        mutation: REGISTER,
        fetchPolicy: 'no-cache'
      })).data.createAccountByUser;


      if(mutationReturn && typeof mutationReturn.token != "undefined" && mutationReturn.token !== null && mutationReturn.token !== "") {
        if(!this.state.accepted_terms) {
          this.setState({
            msg_type: "warning",
            msg: "Você precisa concordar com os termos"
          });
        }
        else {
          document.cookie = "token_user="+mutationReturn.token;// Grava o coookie
          this.setState({
            msg_type: "info",
            msg: "Registro feito com sucesso, aguarde, você será redirecionado."
          });
          window.location.replace('/');
        }
      } else if(mutationReturn && typeof mutationReturn.msg_error != "undefined") {
        this.setState({
          msg_type: "warning",
          msg: mutationReturn.msg_error
        });
      }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.login();
  }

   
  onChange_name = (event) => {
    this.setState({name: event.target.value});
  }
  onChange_cpf = (event) => {
    this.setState({cpf: event.target.value});
  }
  onChange_mail = (event) => {
    this.setState({mail: event.target.value});
  }
  onChange_cellphone = (event) => {
      this.setState({cellphone: event.target.value});
  }
  onChange_phone = (event) => {
      this.setState({phone: event.target.value});
  }
  onChange_title = (event) => {
      this.setState({title: event.target.value});
  }
  onChange_company = (event) => {
      this.setState({company: event.target.value});
  }
  onChange_cnpj = (event) => {
    this.setState({cnpj: event.target.value});
  }
  onChange_pass = (event) => {
    this.setState({pass: event.target.value});
  }
  onChange_repass = (event) => {
    this.setState({repass: event.target.value});
  }

  handleCheckboxChange = (e) => {
    this.setState(state => ({
      ...state,
      accepted_terms: !this.state.accepted_terms
    }));
  }
  

  render() {


    return (
      <div>
        <Navbar fluid className="navbar_blue">
        <Navbar.Header>
          <Navbar.Brand>
          <div className="logo logo_header">
            <img alt="logo" id="logo_top" src={logo} height="26px" />
          </div>
          </Navbar.Brand>
        </Navbar.Header>
        <Navbar.Collapse>
          
        </Navbar.Collapse>
      </Navbar>
      <div className="content content-page">
      <Grid fluid>

      <Row>

        <Col md={12}>
            <h2>Crie uma conta Movti:</h2>
        </Col>  

          <form 
              onSubmit={e => {
                this.handleSubmit(e);
                e.preventDefault();
              }}
              >

            <Col md={6}>

                  
                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_name,
                        name: "name",
                        label: "Nome Completo",
                        type: "text",
                        bsClass: "form-control",
                        placeholder: "Nome Completo",
                        defaultValue: ""
                      }
                    ]}
                  />
                  <FormGroup>
                    <ControlLabel>CPF</ControlLabel>
                    <div>
                    <InputMask 
                      className="form-control"
                      mask="999.999.999-99" 
                      value={this.state.cpf} 
                      onChange={this.onChange_cpf} 
                    />
                    </div>
                  </FormGroup>

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_mail,
                        name: "mail",
                        label: "E-mail",
                        type: "mail",
                        bsClass: "form-control",
                        placeholder: "E-mail",
                        defaultValue: ""
                      }
                    ]}
                  />

                <FormGroup>
                    <ControlLabel>Celular</ControlLabel>
                    <div>
                    <InputMask 
                      className="form-control"
                      mask="(99) 9 9999-9999" 
                      value={this.state.cellphone} 
                      onChange={this.onChange_cellphone} 
                    />
                    </div>
                  </FormGroup>

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_title,
                        name: "title",
                        label: "Cargo",
                        type: "text",
                        bsClass: "form-control",
                        placeholder: "Cargo",
                        defaultValue: ""
                      }
                    ]}
                  />

                  </Col>
                  <Col md={6}>
                  
                <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        onChange:this.onChange_company,
                        name: "company",
                        label: "Empresa",
                        type: "text",
                        bsClass: "form-control",
                        placeholder: "Empresa",
                        defaultValue: ""
                      }
                    ]}
                  />


                  <FormGroup>
                    <ControlLabel>CNPJ</ControlLabel>
                    <div>
                    <InputMask 
                      className="form-control"
                      mask="99.999.999/9999-99" 
                      value={this.state.cnpj} 
                      onChange={this.onChange_cnpj} 
                    />
                    </div>
                  </FormGroup>

                    <FormGroup>
                        <ControlLabel>Telefone da empresa</ControlLabel>
                        <div>
                        <InputMask 
                          className="form-control"
                          mask="(99) 9999-9999" 
                          value={this.state.phone} 
                          onChange={this.onChange_phone} 
                        />
                        </div>
                      </FormGroup>

                      <FormInputs
                        ncols={["col-md-12"]}
                        proprieties={[
                          {
                            onChange:this.onChange_pass,
                            name: "pass",
                            label: "Senha",
                            type: "password",
                            bsClass: "form-control",
                            placeholder: "Senha",
                            defaultValue: ""
                          }
                        ]}
                      />

                      <FormInputs
                        ncols={["col-md-12"]}
                        proprieties={[
                          {
                            onChange:this.onChange_repass,
                            name: "repass",
                            label: "Repetir Senha",
                            type: "password",
                            bsClass: "form-control",
                            placeholder: "Repetir Senha",
                            defaultValue: ""
                          }
                        ]}
                      />
                
                </Col>
                 

                  <Col md={6}>
                      <FormGroup>
                        <ControlLabel>
                          <input
                            value="1"
                            name="accepted_terms"
                            type="checkbox"
                            checked={this.state.accepted_terms}
                            onChange={this.handleCheckboxChange}
                          /> Concordo com os termos e condições
                        </ControlLabel>
                      </FormGroup>
                  </Col>
                  <Col md={6} className="text-right">
                      <Button bsStyle="info" fill type="submit">
                        CADASTRAR
                      </Button>
                  </Col>

                  {
                    this.state.msg &&
                      <Col md={12}>
                        <Alert bsStyle={this.state.msg_type}>
                          {this.state.msg}
                        </Alert>
                      </Col>
                  }
                  

                </form>
            </Row>


            <Row>
            <Col md={12}>
              <Row>
                <Col md={12}>
                    <h2>Nossos Produtos:</h2>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <ProductCard
                      bgImage={background1}
                      avatar={logo_thumb}
                      name="IaaS"
                      userName=""
                      description={
                        <span >
                          <br />
                          <Table className="text-center">
                            <tbody>
                              <tr>
                                <td>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </td>
                              </tr>
                            </tbody>

                          </Table>
                          
                        </span>
                      }
                      
                    />
                </Col>
                <Col md={4}>
                  <ProductCard
                      bgImage={background1}
                      avatar={logo_thumb}
                      name="FWaaS"
                      userName=""
                      description={
                        <span >
                          <br />
                          <Table className="text-center">
                            <tbody>
                              <tr>
                                <td>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </td>
                              </tr>
                            </tbody>

                          </Table>
                          
                        </span>
                      }
                      
                    />
                </Col>
                <Col md={4}>
                  <ProductCard
                      bgImage={background1}
                      avatar={logo_thumb}
                      name="SaaS"
                      userName=""
                      description={
                        <span >
                          <br />
                          <Table className="text-center">
                            <tbody>
                              <tr>
                                <td>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </td>
                              </tr>
                            </tbody>

                          </Table>
                          
                        </span>
                      }
                      
                    />
                </Col>
              </Row>
          </Col>
            </Row>
                 
        </Grid>
      </div>
      </div>
    );
  }
}

export default Register;
